module.exports = __webpack_public_path__ + "static/media/Biotil.d614ff43.jpg";